import {Datagrid, Filter, FunctionField, TextInput, TopToolbar} from "react-admin";
import React, {Fragment} from "react";
import CrudMod from "../../../Component/Layouts/Button/CrudMod";
import CreateGradientButtonMod from "../../../Component/Layouts/Button/CreateGradientButtonMod";
import ListMod from "../../../Component/Redesign/ListMod";
import {convertedDate} from "../../../Functions/ConvertedDate";

const Filters = (props) => (
    <Filter {...props}>
        <TextInput variant="standard" label="Search" source="search" alwaysOn/>
    </Filter>
);

const FileField = ({record}) => {
    if (!record.file) return 'No';
    return (
        <span>{record.file === 1 && 'Yes'}</span>
    );
}

const Categories = ({record}) => {
    if (!record.categories || !record.categories.length) {
        return '';
    }

    const lastElement = record.categories.length - 1;
    return record.categories.map((item, i) => {
        return (
            <Fragment key={i}>
                <span title={item.category}
                      className="category-table-item">{item.category}{i === lastElement ? '' : ', '}</span>
                <br/>
            </Fragment>
        );
    })
};

const SubscriptionField = ({record}) => {
    if (!record.subscription) return 'Not Required';
    return (
        <span>{record.subscription === 1 && 'Required'}</span>
    );
}

const PublishedField = ({record}) => {
    if (!record.published) return 'No';
    return (
        <span>{record.published === 1 && 'Yes'}</span>
    );
}

const LocalsField = ({record}) => {
    if (!record.locales || !record.locales.length) {
        return '';
    }

    const lastElement = record.locales.length - 1;
    return record.locales.map((item, i) => (
        <span key={i}>{item.locale}{i === lastElement ? '' : ', '}</span>
    ))
};

export const Products = (props) => {
    const ListActions = ({className}) => {
        return (<TopToolbar className={className}>
            <div className="actionsWrap">
                <div className="addCategoryBtnWrap">
                    <CreateGradientButtonMod label={'Add New Product'}/>
                </div>
            </div>
        </TopToolbar>);
    };

    return (
        <div className="customTableWrap">
            <ListMod {...props} title="Products" filters={<Filters/>} actions={<ListActions/>}
                     resource="products/general" sort={{field: 'created_at', order: 'DESC'}}>
                <Datagrid bulkActionButtons={false} className="customTable products-table">
                    <FunctionField label="Create Date" source="created_at" sortBy="created_at" render={(record) => {
                        if (!record.created_at) return <></>;
                        return (convertedDate(record.created_at));
                    }}/>
                    <FunctionField label='Name' source="name" sortBy="name" render={(record) => {
                        return (
                            <span title={record.name}>{record.name}</span>
                        );
                    }}/>
                    <FunctionField label='Description' source="description" sortBy="description" render={(record) => {
                        return (
                            <span title={record.description}>{record.description}</span>
                        );
                    }}/>
                    <FunctionField label="File" source="file" render={(record) => {
                        return <FileField sortBy="file" record={record}/>;
                    }}/>
                    <FunctionField label="Categories" source="categories" render={(record) => {
                        return <Categories sortBy="categories" record={record}/>;
                    }}/>
                    <FunctionField label="Subscription" source="subscription" render={(record) => {
                        return <SubscriptionField sortBy="subscription" record={record}/>;
                    }}/>
                    <FunctionField label="Published" source="published" render={(record) => {
                        return <PublishedField sortBy="published" record={record}/>
                    }}/>
                    <FunctionField label="Localization" source="locales" render={(record) => {
                        return <LocalsField sortBy="locales" record={record}/>
                    }}/>
                    <FunctionField label="" source="actions" render={(record) => {
                        return <CrudMod edit="true" del="true" id={record.id} record={record}/>;
                    }}/>
                </Datagrid>
            </ListMod>
        </div>
    )
}

export default Products;
